export const LogoMark = ({ className = "h-8 w-8", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="12" fill={light ? "#F3F0EA" : "#1A1A18"} />
    <path d="M15 49L32 15L49 49" fill="none" stroke={light ? "#1A1A18" : "#F3F0EA"} strokeWidth="4" strokeLinecap="square" strokeLinejoin="miter" />
    <path d="M22 37H42" stroke="#C8694A" strokeWidth="3" />
    <circle cx="22" cy="37" r="3" fill="#C8694A" />
    <circle cx="42" cy="37" r="3" fill="#C8694A" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark light={light} />
    <span className={`font-serif-d text-2xl font-medium tracking-tight ${light ? "text-[var(--stone)]" : "text-[var(--ink)]"}`}>
      Aufbruchwerk<span className="text-[var(--clay)]">.</span>
    </span>
  </span>
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
